(function(){
  var root = document.getElementById('quizRoot');
  var dbg = document.getElementById('dbg');
  if(!root){ return; } // Quiet exit if block isn’t on page
  function logErr(m){ if(dbg){ dbg.textContent='Note: '+m; dbg.style.display='block'; } }

  var total = 8, step = 1;
  var form = document.getElementById('rodQuiz');
  var bar = document.getElementById('progressBar');
  var stepText = document.getElementById('stepText');
  var stepPct = document.getElementById('stepPct');

  function qsel(sel){ return root.querySelector(sel); }
  function qsels(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function showStep(n){ qsels('.step').forEach(function(s){ s.classList.remove('active'); });
                        var t=qsel('.step[data-step="'+n+'"]'); if(t){ t.classList.add('active'); } }
  function progress(){ var pct=Math.round(((step-1)/total)*100);
    if(bar) bar.style.width=pct+'%'; if(stepText) stepText.textContent='Step '+step+' of '+total;
    if(stepPct) stepPct.textContent=pct+'%'; var pr=qsel('.progress'); if(pr) pr.setAttribute('aria-valuenow',pct);
  }

  function next(){ if(step<total){ step++; showStep(step); progress(); } else { submit(); } }

  // Auto-advance
  root.addEventListener('change', function(e){
    var r=e.target; if(r && r.name && /^q[1-8]$/.test(r.name)){ next(); }
  }, true);

  if(form){
    form.addEventListener('submit', function(e){ e.preventDefault(); submit(); });
  }

  function submit(){
    try{
      var data=new FormData(form);
      for(var i=1;i<=total;i++){ if(!data.get('q'+i)){ showStep(i); logErr('Please answer question '+i+'.'); return; } }
      var score={GR:0,BH:0,GA:0,HF:0,DE:0,MZ:0}, map={A:'GR',B:'GA',C:'DE',D:'BH'};
      for(var j=1;j<=total;j++){ score[ map[data.get('q'+j)] || 'GA' ]++; }
      var arr=Object.keys(score).map(function(k){return[k,score[k]];}).sort(function(a,b){return b[1]-a[1];});
      var key=arr[0][0];
      var rods={ GR:"Grande Ronde – 6'6\" 3-wt | Perfect for small streams and technical casts.",
                 BH:"Beaverhead – 7'0\" 4-wt | All-arounder with finesse and versatility.",
                 GA:"Gallatin – 7'6\" 4-wt | Balanced and forgiving for a range of water.",
                 HF:"Henrys Fork – 8'0\" 5-wt | Classic trout rod with smooth delivery.",
                 DE:"Deschutes – 8'6\" 5-wt | Powerful Para taper built for wind and distance.",
                 MZ:"McKenzie – 8'6\" 5-wt | Dickerson taper, great for covering water." };

      // Finish progress
      step=total+1; if(bar) bar.style.width='100%'; if(stepText) stepText.textContent='Complete'; if(stepPct) stepPct.textContent='100%';

      var res=document.getElementById('result'); var txt=document.getElementById('rod-match');
      if(txt) txt.textContent=rods[key];
      if(res){ res.style.display='block'; setTimeout(function(){ res.style.opacity='1'; }, 20); }
      window.__quizMatchText = rods[key];
    } catch(err){ logErr('Script error: '+(err && err.message? err.message: err)); }
  }

  // Save email + redirect
  var saveBtn=document.getElementById('saveBtn');
  if(saveBtn){
    saveBtn.addEventListener('click', function(){
      var email=(document.getElementById('resultEmail')||{}).value||'';
      if(!email){ alert('Please enter your email.'); return; }
      try{ if(window._learnq){ window._learnq.push(['identify',{ $email: email, quiz_result: window.__quizMatchText || (document.getElementById('rod-match')?document.getElementById('rod-match').textContent:'') }]); } }catch(e){}
      window.location.href='/products/deluxe-series';
    });
  }

  // Init
  showStep(step); progress();
})();
